import React from "react";

interface ILeftPanelIconProps {
    sizeX?: number;
    sizeY?: number;
}

export const LeftPanelIcon: React.FC<ILeftPanelIconProps> = ({ sizeX = 24, sizeY = 24 }) => {
    return (
        <svg width={sizeX} height={sizeY} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
             stroke="currentColor"
             strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
             aria-hidden="true">
            <rect width="18" height="18" x="3" y="3" rx="2"></rect>
            <path d="M9 3v18"></path>
            <path d="m14 9 3 3-3 3"></path>
        </svg>
    );
};
